import Image from "next/image";

import { Props } from "./types";

const Card = ({ title, subtitle, size = "big", image }: Props): JSX.Element => {
  return (
    <div className={`flex flex-row lg:flex-col items-center md:justify-center lg:w-[340px]`}>
      <div className={`relative w-1/4 md:w-1/3 xl:w-44 xl:h-36 text-center px-5 md:px-0`}>
        <Image src={image} alt={title} objectFit="contain" />
      </div>

      <div className="flex flex-col justify-start text-left lg:text-center md:items-start lg:items-center lg:justify-center w-3/4 md:w-2/3 lg:w-full max-w-full">
        <h3
          className={`text-landing-blue md:leading-10 font-sans font-bold md:text-2xl lg:my-5 lg:text-[32px] md:font-bold lg:mb-3`}
        >
          {title}
        </h3>

        <p className="leading-6 text-left md:w-auto lg:text-center md:font-sans md:font-normal md:text-base text-landing-blue">
          {subtitle}
        </p>
      </div>
    </div>
  );
};

export default Card;
